import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { MasterDataStore } from '../services/master-data.store';
import { UrlConstants } from './../../pages/common/constants/url.constants';

@Component({
  selector: 'app-page-header',
  imports: [NgOptimizedImage],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    style: 'display: block; width: 100%;',
  },
})
export class PageHeaderComponent {
  /** マスタデータストア（アプリ起動時に一度だけロードする） */
  private readonly masterDataStore = inject(MasterDataStore);

  /**
   * ロゴクリック時にオフィシャルHPを新しいタブで表示
   */
  openOfficialSite(): void {
    const url = this.masterDataStore.getTransitionDestinationUrl(UrlConstants.COMPANY_ICON_URL) ?? 'https://www.dai-ichi-life.co.jp/';
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
